import {FormControlLabel} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

import {theme} from '../theme'

const styles = {
  label: {
    fontWeight: theme.typography.fontWeightMedium as any,
    fontSize: 18,
    lineHeight: '26px',
  },
}

export default withStyles(styles, {name: 'LPCFormControlLabel'})(FormControlLabel)
